import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
  OnInit,
  ViewChild,
  AfterViewInit
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR
} from '@angular/forms';

@Component({
  selector: 'axis-checkbox',
  templateUrl: './checkbox.component.html',
  host: {
    class: 'axis-checkbox'
  },
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true
    }
  ]
})
export class CheckboxComponent implements OnInit, AfterViewInit {
  @Input() public ariaLabel: string;
  @Input() tabIndex: any;
  @Input() checked: boolean = undefined;
  @Input() disabled: boolean;
  @Input() heading = '';
  // tslint:disable-next-line: no-input-rename
  @Input('cid') id: string;
  @Input() name: string;
  @Input() rel: string;
  @Input() required = false;
  @Input() value: string;

  @Output() changeDetect = new EventEmitter();
  @Output() onChangeEvent = new EventEmitter();
  @Output() emitBlurEvent = new EventEmitter();
  @ViewChild('label') labelSection: any;
  private propagateModelChange = (_: any) => {};
  private OnTouchedEvent = () => {};

  constructor(public _changeDetRef: ChangeDetectorRef) {}

  ngOnInit() {
    if (!this.id) {
      this.id = (Math.random() + Math.random()).toString().replace('.', '');
    }
  }
  ngAfterViewInit() {
    const innerHTML = this.labelSection.nativeElement.innerHTML;
    if (!innerHTML) {
      this.labelSection.nativeElement.innerHTML = this.heading;
    } else {
      this.labelSection.nativeElement.innerHTML = (this.heading || '') + ' ' + innerHTML;
    }
  }
  toggleCheck() {
    this.checked = !this.checked;
  }
  check() {
    this.checked = true;
  }
  unCheck() {
    this.checked = false;
  }
  disable() {
    this.disabled = true;
  }
  activate() {
    this.disabled = false;
  }
  onChange(e?) {
    this.propagateModelChange(this.checked);
    const model = {
      name: this.name,
      value: this.value
    };
    this.onChangeEvent.emit(model);
    this.changeDetect.emit(this.checked);
    this.OnTouchedEvent();
  }
  toggleDisable() {
    this.disabled = !this.disabled;
  }
  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }
  emitOnBlurEvent() {
    this.emitBlurEvent.emit();
    this.OnTouchedEvent();
  }
  // Implementing ControlValueAccessor for checkbox
  // ::For custom form validations(triggered when assigned to ngModel)

  writeValue(value: any) {
    this.checked = value;
  }
  registerOnChange(fn: any): void {
    this.propagateModelChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.OnTouchedEvent = fn;
  }
  validate(control: AbstractControl): { [key: string]: any } {
    if (this.required) {
      if (control.value) {
        return null;
      }
      return { axisCheckbox: { valid: false } };
    }
  }
  // ControlValueAccessor ENDS
}
